import React, { useEffect } from 'react'
import { COLORS } from '@btime/constants'
import FlexGrid from '../../../components/structure/FlexGrid'
import Button from '../../../components/actions/Button'
import Separator from '../../../components/helpers/Separator'
import { Col } from '../../../components/tables/Table'
import { useCurrentModal } from '../../../components/modals/ModalsContext'
import { useOpenEditServiceOrdersModal } from '../../../utils/routes/modals/modalsActions'
import { useSaveServiceOrders } from './_requests/saveServiceOrders'
import { useTranslation } from 'react-i18next'

const CreateButton = () => {
  const { t } = useTranslation('duplicates')
  const { data } = useCurrentModal()
  const [onSubmit, { loading }] = useSaveServiceOrders()

  return (
    <Button onClick={() => onSubmit(data?.duplicateInputs)} loading={loading} color={COLORS.dark4} transparent>
      {t('create')}
    </Button>
  )
}

const EditButton = () => {
  const { t } = useTranslation('duplicates')
  const { data } = useCurrentModal()
  const openBulkEditModal = useOpenEditServiceOrdersModal()

  return (
    <Button onClick={() => openBulkEditModal({ ids: data?.duplicateIds })} color={COLORS.primary}>
      {t('edit')}
    </Button>
  )
}

const ModelFooter = () => {
  return (
    <>
      <Separator weight={6} />
      <FlexGrid justify="right" gutter={0.3}>
        <Col>
          <CreateButton />
        </Col>
        <Col>
          <EditButton />
        </Col>
      </FlexGrid>
    </>
  )
}

export default ModelFooter
